import React from 'react'
import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useBreakpoint } from '@root/shared/hooks/useBreakpoint'
import { ArrowLeftIcon, mediaMinTablet } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type SettingsHeaderProps = {
  onBack: () => void
  title: React.ReactNode
  endContent?: React.ReactNode
} & ClassNameProps

export const SettingsHeader: React.FC<SettingsHeaderProps> = ({
  onBack,
  title,
  endContent,
  className,
}) => {
  const breakpoint = useBreakpoint()
  const isMobile = breakpoint === 'mobile'

  return (
    <Root className={className}>
      <Button
        variant="secondary"
        size={isMobile ? 'xs' : 's'}
        iconLeft={<ArrowLeftIcon />}
        onClick={onBack}
      />
      <Title>{title}</Title>
      {endContent}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding-block: 16px 8px;
  padding-inline: 12px;

  ${mediaMinTablet(css`
    padding-inline: 24px;
  `)}
`

const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: var(--text-12);
  text-align: center;

  ${mediaMinTablet(css`
    font-size: 24px;
    font-weight: 700;
  `)}
`
